

















































































































































































































































































































































































































































import Vue from "vue";
import vIcon from "@/components/v-components/v-icon.vue";
import moment from "moment-timezone";
import { mapGetters, mapActions } from "vuex";
import { Localize } from "@/plugins/localization";
import Controls from "@/components/vue-components/Controls.vue";
import router from "@/router";
import VSelect from "@/components/v-components/v-select.vue";
import { TranslateResult } from "vue-i18n";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";
import BtnLoadingIndicator from "@/components/vue-components/BtnLoadingIndicator.vue";
import {
  companyUrlValidator,
  emailValidator,
  lowercaseValidator,
  maxLengthValidator,
  minLengthValidator,
  numberValidator,
  phoneNumberValidator,
  requiredValidator,
  specialCharValidator,
  uppercaseValidator
} from "@/common/validators";
import { trackRegistrationComplete } from "@/utils/attribution";

interface SubmitButtonIndicator {
  btnLoadingIndicatorOn: () => Promise<void>;
  btnLoadingIndicatorSuccess: () => Promise<boolean>;
  btnLoadingIndicatorInvalid: () => Promise<void>;
}

export default Vue.extend({
  name: "Register",
  components: {
    vIcon,
    VSelect,
    Controls,
    VelloIcon,
    BtnLoadingIndicator
  },
  data: () => {
    return {
      email: "" as string,
      password: "" as string,
      firstName: "" as string,
      lastName: "" as string,
      phone: "" as string,
      companyName: "" as string,
      velloUrl: "" as string,
      timezone: moment.tz.guess() as string,
      language: Localize.getSupportedLanguagesList().find(
        obj =>
          obj.key ===
          ((router.currentRoute.params.locale ||
            Localize.getUserLocale().localeNoIso) as string)
      ) || { key: "en", label: "English" },
      timeZoneOptions: Localize.getSupportedTimeZonesList(),
      languageOptions: Localize.getSupportedLanguagesList(),
      acceptedTerms: false as boolean,
      isSubmitting: false as boolean,
      errors: {
        email: null,
        password: null,
        firstName: null,
        lastName: null,
        phone: null,
        companyName: null,
        velloUrl: null,
        tos: null
      } as {
        [key: string]: TranslateResult | string | null;
      },
      locale: router.currentRoute.params.locale as string,
      baseUrl: process.env.VUE_APP_VELLO_URL as string,
      baseUrlNew: process.env.VUE_APP_MARKETPLACE_URL as string
    };
  },
  computed: {
    ...mapGetters([
      "GET_CSRF_INFORMATION",
      "GET_REGISTER_VALIDATION_STATUS",
      "GET_REGISTER_STATUS",
      "GET_USER_STATUS",
      "COMPANY_GET_WIZARD"
    ])
  },
  created() {
    const userState = this.GET_USER_STATUS.status;
    if (userState) this._Temp_handleAllreadLoggedIn();
  },
  methods: {
    ...mapActions([
      "USER_VALIDATE_SIGNUP",
      "USER_REGISTER",
      "USER_LOGIN",
      "COMPANY_PREPARE_WIZARD",
      "UPDATE_NOTIFICATION_STATUS"
    ]),

    getPlaceholder(type: string): TranslateResult | undefined {
      switch (type) {
        case "timezone":
          return this.$i18n.t(
            "register.form.select-timezone-search-placeholder"
          );
        case "language":
          return this.$i18n.t(
            "register.form.select-language-search-placeholder"
          );
        default:
          break;
      }
    },

    handleCancelRegister(): void {
      window.location.replace(
        `${process.env.VUE_APP_VELLO_URL}/${this.language.key}`
      );
    },

    handleClickLogin(): void {
      this.$router.push({ name: "Login" });
    },
    // Validate methods
    validateEmail(): void {
      this.errors.email =
        [
          requiredValidator(
            this.email,
            this.$i18n.t("register.form.errors.email.missing")
          ),
          maxLengthValidator(
            this.email,
            this.$i18n.t("register.form.errors.email.too-long")
          ),
          emailValidator(
            this.email,
            this.$i18n.t("register.form.errors.email.invalid")
          )
        ].find(e => e) || null;
    },
    validatePassword(): void {
      this.errors.password =
        [
          requiredValidator(
            this.password,
            this.$i18n.t("register.form.errors.pswd.missing")
          ),
          minLengthValidator(
            this.password,
            this.$i18n.t("register.form.errors.pswd.too-short"),
            15
          ),
          maxLengthValidator(
            this.password,
            this.$i18n.t("register.form.errors.pswd.too-long")
          ),
          uppercaseValidator(
            this.password,
            this.$i18n.t("register.form.errors.pswd.no-uppercase")
          ),
          lowercaseValidator(
            this.password,
            this.$i18n.t("register.form.errors.pswd.no-lowercase")
          ),
          numberValidator(
            this.password,
            this.$i18n.t("register.form.errors.pswd.no-number")
          ),
          specialCharValidator(
            this.password,
            this.$i18n.t("register.form.errors.pswd.no-special-char")
          )
        ].find(e => e) || null;
    },
    validateFirstname(): void {
      this.errors.firstName =
        [
          requiredValidator(
            this.firstName,
            this.$i18n.t("register.form.errors.firstname.missing")
          ),
          maxLengthValidator(
            this.firstName,
            this.$i18n.t("register.form.errors.firstname.too-long")
          )
        ].find(e => e) || null;
    },
    validateLastname(): void {
      this.errors.lastName =
        [
          requiredValidator(
            this.lastName,
            this.$i18n.t("register.form.errors.lastname.missing")
          ),
          maxLengthValidator(
            this.lastName,
            this.$i18n.t("register.form.errors.lastname.too-long")
          )
        ].find(e => e) || null;
    },
    validatePhone(): void {
      this.errors.phone =
        [
          requiredValidator(
            this.phone,
            this.$i18n.t("register.form.errors.phone-number.missing")
          ),
          maxLengthValidator(
            this.phone,
            this.$i18n.t("register.form.errors.phone-number.too-long")
          ),
          phoneNumberValidator(
            this.phone,
            this.$i18n.t("register.form.errors.phone-number.invalid")
          )
        ].find(e => e) || null;
    },
    validateCompanyName(): void {
      this.errors.companyName =
        [
          requiredValidator(
            this.companyName,
            this.$i18n.t("register.form.errors.company-name.missing")
          ),
          maxLengthValidator(
            this.companyName,
            this.$i18n.t("register.form.errors.company-name.too-long")
          )
        ].find(e => e) || null;
    },
    validateVelloUrl(): void {
      this.errors.velloUrl =
        [
          requiredValidator(
            this.velloUrl,
            this.$i18n.t("register.form.errors.vello-url.missing")
          ),
          maxLengthValidator(
            this.velloUrl,
            this.$i18n.t("register.form.errors.vello-url.too-long")
          ),
          companyUrlValidator(
            this.velloUrl,
            this.$i18n.t("register.form.errors.vello-url.invalid")
          )
        ].find(e => e) || null;
    },
    validateTos(): void {
      this.errors.tos =
        [
          requiredValidator(
            this.acceptedTerms,
            this.$i18n.t("register.form.errors.terms-agree.missing")
          )
        ].find(e => e) || null;
    },
    validateForm(): boolean {
      this.validateEmail();
      this.validatePassword();
      this.validateFirstname();
      this.validateLastname();
      this.validatePhone();
      this.validateCompanyName();
      this.validateVelloUrl();
      this.validateTos();

      return Object.values(this.errors).every(e => e === null);
    },
    getSubmitButton(): SubmitButtonIndicator {
      return (this.$refs.submitButton as unknown) as SubmitButtonIndicator;
    },
    handleFormSubmit(): void {
      if (this.isSubmitting) return;
      if (!this.validateForm()) return;
      this.isSubmitting = true;
      const button = this.getSubmitButton();
      button.btnLoadingIndicatorOn();
      this.$store
        .dispatch("USER_VALIDATE_SIGNUP", {
          data: this.getFormData("validate"),
          token: this.GET_CSRF_INFORMATION.token
        })
        .then(() => {
          if (
            this.GET_REGISTER_VALIDATION_STATUS.response.email_already_exists
          ) {
            this.errors.email = this.$i18n.t(
              "register.form.errors.email.exists"
            );
            throw new Error("emailAlreadyExists");
          }
          return this.$store.dispatch("USER_REGISTER", {
            data: this.getFormData("register"),
            token: this.GET_CSRF_INFORMATION.token
          });
        })
        .then(() => {
          if (this.GET_REGISTER_STATUS.email === "") {
            this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
              status: true,
              component: "error"
            });
            throw new Error("account creation error");
          }
          return this.tryLoginRecursively();
        })
        .then(() => {
          return this.$store.dispatch("COMPANY_PREPARE_WIZARD", {
            data: this.getFormData("wizard"),
            token: this.GET_CSRF_INFORMATION.token
          });
        })
        .then(() => {
          const revealed = button.btnLoadingIndicatorSuccess();
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "vello_event_captured",
            captured_event_name: "sign_up",
            captured_event_params: {
              event_category: "engagement",
              event_label: "method"
            }
          });
          this.$gtag.event("sign_up", {
            event_category: "engagement",
            event_label: "method"
          });
          window.dataLayer.push({
            event: "vello_event_captured",
            captured_event_name: "conversion",
            captured_event_params: {
              send_to: "AW-940295887/PrP8CNLyi-4CEM-Nr8AD"
            }
          });
          this.$gtag.event("conversion", {
            send_to: "AW-940295887/PrP8CNLyi-4CEM-Nr8AD"
          });
          return trackRegistrationComplete(this.email).then(() => revealed);
        })
        .then(() => {
          window.location.replace(
            `${process.env.VUE_APP_VELLO_URL}/${this.COMPANY_GET_WIZARD.companyUrl}`
          );
        })
        .catch(() => {
          button.btnLoadingIndicatorInvalid().then(() => {
            this.isSubmitting = false;
          });
          if (this.GET_REGISTER_VALIDATION_STATUS.connectionError) {
            this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
              status: true,
              component: "error"
            });
            throw new Error("validation-connectionError");
          }
          if (
            this.GET_REGISTER_STATUS.connectionError ||
            this.GET_REGISTER_STATUS.error
          ) {
            this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
              status: true,
              component: "error"
            });
            throw new Error("register-connectionError");
          }
          if (this.GET_USER_STATUS.connectionError) {
            this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
              status: true,
              component: "error"
            });
            throw new Error("user-connectionError");
          }
          if (this.COMPANY_GET_WIZARD.didInvalidate) {
            this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
              status: true,
              component: "error"
            });
            throw new Error("wizardInitError");
          }
        });
    },

    tryLoginRecursively(): Promise<unknown> {
      const delayBetweenReg = 3000 as number;
      const maxTries = 3 as number;
      let tries = 0 as number;
      return new Promise((resolve, reject) => {
        const login = () => {
          this.$store
            .dispatch("USER_LOGIN", {
              credentials: this.getFormData("login"),
              token: this.GET_CSRF_INFORMATION.token
            })
            .finally(() => {
              if (typeof this.GET_USER_STATUS.user.id !== "undefined") {
                return resolve(true);
              }

              if (
                typeof this.GET_USER_STATUS.user.id === "undefined" &&
                tries === maxTries
              ) {
                return reject("server error");
              }
              setTimeout(() => {
                tries += 1;
                login();
              }, delayBetweenReg);
            });
        };
        login();
      });
    },

    handlePrepareVelloUrl(): void {
      const urlSuggestion = encodeURIComponent(
        this.companyName
          .normalize("NFD")
          .replace(/[^a-zA-Z0-9/ /_-]|[\u0300-\u036f]/gi, "")
          .replace(/ /g, "-")
          .replace(/\//g, "")
          .toLowerCase()
      );
      this.velloUrl = urlSuggestion;
    },

    getFormData(type: string): object {
      let formData = {};
      switch (type) {
        case "validate":
          return (formData = {
            company: this.companyName.trim(),
            email: this.email.trim(),
            first_name: this.firstName.trim(),
            language: this.language.key,
            last_name: this.lastName.trim(),
            office: this.companyName.trim(),
            password: this.password.trim(),
            phone: this.phone.trim().replace(/[^0-9+]/g, ""),
            timezone: this.timezone,
            vello_url: this.velloUrl.trim(),
            voucher: ""
          });
        case "register":
          return (formData = {
            email: this.email.trim(),
            first_name: this.firstName.trim(),
            language: this.language.key,
            last_name: this.lastName.trim(),
            name: `${this.firstName} ${this.lastName}`,
            password: this.password.trim(),
            phone: this.phone.trim().replace(/[^0-9+]/g, ""),
            timezone: this.timezone
          });
        case "login":
          return (formData = {
            email: this.email.trim(),
            password: this.password.trim(),
            url: this.velloUrl.trim()
          });
        case "wizard":
          return (formData = {
            company: {
              name: this.companyName.trim(),
              settings: {},
              url: this.velloUrl.trim()
            },
            office: {
              name: this.companyName.trim()
            },
            language: this.language.key,
            timezone: this.timezone
          });
        default:
          return formData;
      }
    },

    _Temp_handleAllreadLoggedIn(): void {
      this.$store
        .dispatch("USER_LOGOUT", this.GET_CSRF_INFORMATION.token)
        .then(() => {
          return this.$store.dispatch("FETCH_CSRF_INFORMATION");
        })
        .catch(error => {
          console.error(error);
          this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
            status: true,
            component: "error"
          });
        });
    }
  }
});
